module.exports = __webpack_public_path__ + "img/195.a6095730.jpg";